module.exports = __webpack_public_path__ + "img/字段匹配.4bd42cd8.svg";